module.exports = __webpack_public_path__ + "img/7d6c770.jpg";